function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m376 91h-240c-24.8125 0-45 20.1875-45 45v240c0 24.8125 20.1875 45 45 45h240c24.8125 0 45-20.1875 45-45v-240c0-24.8125-20.1875-45-45-45zm-120 270c-57.890625 0-105-47.109375-105-105s47.109375-105 105-105 105 47.109375 105 105-47.109375 105-105 105zm105-180c-16.539062 0-30-13.460938-30-30s13.460938-30 30-30 30 13.460938 30 30-13.460938 30-30 30zm0 0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m256 181c-41.351562 0-75 33.648438-75 75s33.648438 75 75 75 75-33.648438 75-75-33.648438-75-75-75zm0 0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m436 0h-360c-41.351562 0-76 34.648438-76 76v360c0 41.351562 34.648438 76 76 76h360c41.351562 0 76-34.648438 76-76v-360c0-41.351562-34.648438-76-76-76zm15 376c0 41.351562-33.648438 75-75 75h-240c-41.351562 0-75-33.648438-75-75v-240c0-41.351562 33.648438-75 75-75h240c41.351562 0 75 33.648438 75 75zm0 0"
});

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.00ab1b70.svg";
export { ForwardRef as ReactComponent };